// material-ui
import logo from 'assets/images/logo.png';
import { Typography } from "@mui/material";

// ==============================|| LOGO SVG ||============================== //

const Logo = ({ imageSize = 50, visibleTitle = true }) => {
    return (
        <>
            <img src={logo} alt="Gardener" height={imageSize}/>
            { visibleTitle && (
                <Typography sx={{marginLeft: "10px", color: "#00C473"}} variant="h3">GARDENER</Typography>
            )}
        </>
    );
};

export default Logo;
